import { useSelectionContext } from './selection/SelectionContext'

import { useSelectStateContext } from './SelectStateContext'

export const ClearButton = () => {
  const { selectedValues, clearSelection } = useSelectionContext()
  const { disabled, readonly } = useSelectStateContext()

  if (!selectedValues || disabled || readonly) return null

  // to ensure the same experience / visual as with the native "search" button "clear"
  return (
    <button
      className="select-clear-button"
      type="button"
      onClick={_ => {
        clearSelection()
      }}
    />
  )
}

ClearButton.displayName = 'SelectClearButton'
